import { removeParamsFromQuery } from '@marketplace-web/browser/url-util'

export const removeFeedbackUrlParam = (relativeUrl: string, urlQuery: string) =>
  removeParamsFromQuery(relativeUrl, urlQuery, ['offline_verification_feedback_seller'])

const falselyStrings = ['0', 'f', 'F', 'false', 'FALSE', 'off', 'OFF']

export const isStringTruthy = (value: unknown) =>
  typeof value === 'string' && !falselyStrings.includes(value)
